/**
 * 관심매장 목록 sessionStorage 복원용 순수 함수.
 * like page와 use-infinite-scroll-liked-stores 훅에서 공용.
 */
export interface RestoredLikedStores {
  stores: unknown[];
  offset: number;
  hasMore: boolean;
}

export function getRestoredLikedStores(
  storageKey: string,
  currentLocationKey: string
): RestoredLikedStores | null {
  try {
    const savedStores = sessionStorage.getItem(`${storageKey}:allStores`);
    const savedOffset = sessionStorage.getItem(`${storageKey}:offset`);
    const savedHasMore = sessionStorage.getItem(`${storageKey}:hasMore`);
    const savedLocationKey = sessionStorage.getItem(
      `${storageKey}:locationKey`
    );

    if (savedLocationKey !== currentLocationKey) {
      return null;
    }

    if (savedStores != null && savedOffset != null && savedHasMore != null) {
      return {
        stores: JSON.parse(savedStores),
        offset: parseInt(savedOffset, 10),
        hasMore: savedHasMore === "true",
      };
    }
  } catch (error) {
    console.error("Failed to restore from storage:", error);
  }
  return null;
}
